import { apiClient } from './client';
import { Funcionario } from '../types';

export interface DadosFuncionario {
  nome: string;
  cargo?: string;
  celular?: string;
  cnh?: string;
  salario?: number | string;
  tipo_contrato?: string;
  data_admissao?: string;
  eh_motoboy?: boolean;
  app_motoboy_ativo?: boolean;
  senha_app?: string;
}

export function listarFuncionarios(): Promise<Funcionario[]> {
  return apiClient.get('/funcionarios').then((res) => res.data.funcionarios);
}

export function criarFuncionario(dados: DadosFuncionario): Promise<Funcionario> {
  return apiClient.post('/funcionarios', dados).then((res) => res.data.funcionario);
}

export function atualizarFuncionario(id: number, dados: DadosFuncionario): Promise<Funcionario> {
  return apiClient.put(`/funcionarios/${id}`, dados).then((res) => res.data.funcionario);
}

export function removerFuncionario(id: number): Promise<{ ok: boolean }> {
  return apiClient.delete(`/funcionarios/${id}`).then((res) => res.data);
}
